import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './components/App'

export let startAdaExceptions = (
  courseObj,
  studentObj,
  aggregatedRules,
  lateRulesList,
  timeLimitRulesList
) => {
  ReactDOM.render(
    <App
      coursenum={courseObj.coursenum}
      courseTitle={courseObj.title}
      timezone={courseObj.timezone}
      studentName={studentObj.fullName}
      studentId={studentObj.id}
      aggregatedRules={aggregatedRules}
      lateRulesList={lateRulesList}
      timeLimitRulesList={timeLimitRulesList}
    />,
    document.getElementById('ada_exceptions_anchor')
  )
}
